<template>
  <div>
    <div class="table-body md:ut-rounded ut-bg-neutral-001 font-small ut-mb-2 md:ut-flex md:ut-h-20 md:ut-p-0 sm:ut-block ut-p-4 sm:ut-text-left">
      <div class="section md:ut-w-3/5 sm:ut-flex ut-w-full">
        <div class="ut-w-3/5 md:ut-pl-4">
          <div class="font-xxs md:ut-hidden">Address</div>
          <div class="">{{ propertyAddress | truncateString(40) }}</div>
        </div>
        <div class="property-features ut-w-2/5">
          <div class="font-xxs md:ut-hidden">Features</div>
          <ul class="md:ut-pl-4 ut-justify-start">
            <li v-if="property.beds" class="ut-text-neutral-400 ut-text-center">
              <svg-loader name="icon-bed" :width="20" /> {{ property.beds }}
            </li>
            <li v-if="property.bath" class="ut-text-neutral-400 ut-text-center">
              <svg-loader name="icon-bath" :width="20" /> {{ property.bath }}
            </li>
            <li v-if="property.car" class="ut-text-neutral-400 ut-text-center">
              <svg-loader name="icon-car" :width="20" /> {{ property.car }}
            </li>
          </ul>
        </div>
      </div>
        <div class="section md:ut-w-2/5 md:ut-pl-4 sm:ut-flex ut-w-full ut-pt-4 md:ut-pt-0">
          <div class="md:ut-w-1/2 ut-w-3/5">
            <div class="font-xxs md:ut-hidden">Sale date</div>
            <div>{{soldDate}}</div>
          </div>
          <div class="md:ut-w-1/2 ut-w-2/5">
            <div class="font-xxs md:ut-hidden">Sale price</div>
            <div v-if="soldPrice">{{soldPrice}}</div>
            <div v-else>
              <div v-if="!updateClicked">
                <a
                  @click="updateClicked = true"
                  v-gaEvent="gaEvent('Agent Sales View - Click Add Price Link')">
                  Add price
                </a>
              </div>
              <div v-else>
                <div class="ut-flex">
                  <input
                    class="ut-w-16"
                    type="Number"
                    :placeholder="'$...'"
                    v-model="value"
                    :class="[ isError ? 'error' : '']" />
                  <img
                    @click="validate"
                    :disabled="disableSubmit"
                    class="ut-w-5 ut-mx-1 ut-cursor-pointer"
                    src="@/assets/styles/frontend-library/images/check.svg"
                    v-gaEvent="gaEvent('Agent Sales View - Click Validate Price')"
                  />
                  <img
                    @click="cancel"
                    class="ut-w-5 ut-mx-1 ut-cursor-pointer"
                    src="@/assets/styles/frontend-library/images/close.svg"
                    v-gaEvent="gaEvent('Agent Sales View - Click Cancel Add Price')"
                  />
                </div>
                <span v-if="isError" id="error-message" class="error inline ut-leading-none ut-mb-0 ut-mt-1">{{ errorMsg }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import SvgLoader from '@oa-vue/svg-loader/SvgLoader.vue';

export default {
  name: 'ListingCard',
  components: {
    SvgLoader,
  },
  props: {
    property: {
      required: true,
    },
  },
  data() {
    return {
      disableSubmit: false,
      updateClicked: false,
      value: '',
      errorMsg: '',
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    gaLabel() {
      return `AID=${this.agent.id} | PK=${this.property.key}`;
    },
    propertyAddress() {
      return `${this.property.streetaddress} `
        + `${this.$options.filters.titleCase(this.property.street)}, `
        + `${this.$options.filters.titleCase(this.property.suburb)} `;
    },
    soldDate() {
      if (this.property.saledate && this.property.saledate.length > 0) {
        const splittedDate = this.property.saledate.split('/');
        if (splittedDate.length >= 3) {
          return this.$options.filters.formatDate(`${splittedDate[1]}/${splittedDate[0]}/${splittedDate[2]}`);
        }
      }
      return '-';
    },
    soldPrice() {
      if (this.property.saleprice
        && this.property.saleprice.length > 0) {
        const price = this.$options.filters.formatPrice(this.property.saleprice);
        if (price !== '0') {
          return `$${price}`;
        }
      }
      return null;
    },
    isError() {
      return this.errorMsg !== '';
    },
  },
  methods: {
    validate() {
      this.errorMsg = '';
      // Validate price
      if (this.value.length === 0) {
        this.errorMsg = 'Missing value';
      } else if (this.value.length < 5) {
        this.errorMsg = 'Price is to low';
      } else if (this.value.length > 7) {
        this.errorMsg = 'Price is too high';
      }
      if (!this.isError) {
        this.setPropertyPrice();
      }
    },
    cancel() {
      this.updateClicked = false;
      this.value = '';
      this.errorMsg = '';
    },
    setPropertyPrice() {
      this.disableSubmit = true;
      const data = {
        propertysaleprice: this.value,
      };
      this.$apiServices.oa.property.updatePrice(this.property.key, data)
        .then(() => {
          this.$helpers.gaEvent('AgentPortal',
            'Agent Sales View - Add Price',
            `${this.gaLabel} | val=${this.value}`);
          this.property.saleprice = `${this.value}`;
          this.updateClicked = false;
          this.value = '';
          this.errorMsg = '';
          this.disableSubmit = false;
        });
    },
    gaEvent(eventAction) {
      return {
        category: 'AgentPortal',
        action: eventAction,
        label: this.gaLabel,
      };
    },
    // gaEventNewPrice(eventAction) {
    //   const event = this.gaEvent(eventAction);
    //   console.log(`this.value:${this.value}`)
    //   event.label = `${event.label} | val=${this.value}`;
    //   console.log(`event label:${event.label}`)
    //   console.log(event)
    //   return event;
    // },
  },
};

</script>

<style scoped lang="scss">

.table-body {
  border: 1px solid #E3E5E8;
}

.lead-card-col-small {
  float: left;
  @apply ut-mr-8 ;
}

.font-small {
  @apply ut-opacity-100 ;
  @screen md {
    @apply ut-opacity-75;
  }
}

.section {
  @apply ut-mx-0;
  display: inline-flex;
}

.property-features {

ul {
    @apply  ut-flex;
    // display: -webkit-inline-box;

    li {
      @apply ut-mr-5 ut-ml-0;

        img {
          @apply ut-w-5;
          vertical-align: sub;
        }
    }
  }
}

a {
  @apply ut-block ut-underline ut-text-green-400;
}

</style>
